import Reflux from 'reflux';
import TeamData from 'shared/data/Team';

let async = { asyncResult: true },
  TeamActions = Reflux.createActions({
    updateField: async,
    updatePhoto: async,
    checkForExistingTitle: async,
  });

TeamActions.updateField.listenAndPromise((teamId, field, value) => {
  let changes = {};
  changes[field] = value;
  return TeamData.update(teamId, changes);
});

TeamActions.updatePhoto.listenAndPromise(TeamData.updatePhoto);

TeamActions.checkForExistingTitle.listenAndPromise((title) => {
  return TeamData.checkForExistingTitle(title);
});

export default TeamActions;
